var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3839 10.4611C34.9508 10.4552 34.5257 10.5779 34.1623 10.8136C33.7989 11.0493 33.5136 11.3875 33.3424 11.7853C33.1712 12.1832 33.1218 12.6229 33.2005 13.0488C33.2792 13.4747 33.4824 13.8677 33.7844 14.1781C34.0865 14.4886 34.4738 14.7025 34.8974 14.7928C35.321 14.8831 35.7619 14.8458 36.1643 14.6856C36.5666 14.5253 36.9125 14.2494 37.1581 13.8926C37.4036 13.5358 37.5379 13.1142 37.5439 12.6811V12.6211C37.5386 12.0499 37.3094 11.5035 36.9054 11.0996C36.5015 10.6956 35.9551 10.4664 35.3839 10.4611Z",
    stroke: "#FAFAFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.55 5.50064H7.45C6.92828 5.51369 6.43233 5.73015 6.068 6.10382C5.70367 6.47748 5.49984 6.97876 5.5 7.50064V40.6006C5.5 41.1311 5.71071 41.6398 6.08579 42.0149C6.46086 42.3899 6.96957 42.6006 7.5 42.6006H40.6C41.1304 42.6006 41.6391 42.3899 42.0142 42.0149C42.3893 41.6398 42.6 41.1311 42.6 40.6006V7.45064C42.5935 7.18797 42.5353 6.92915 42.4288 6.68898C42.3222 6.4488 42.1694 6.23197 41.979 6.05088C41.7887 5.86979 41.5645 5.72799 41.3193 5.63358C41.0741 5.53916 40.8127 5.49399 40.55 5.50064Z",
    stroke: "#FAFAFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9988 15.7188C22.3611 15.7188 20.7603 16.2044 19.3986 17.1142C18.037 18.024 16.9757 19.3172 16.349 20.8301C15.7223 22.3431 15.5584 24.0079 15.8779 25.6141C16.1973 27.2203 16.9859 28.6956 18.1439 29.8536C19.3019 31.0116 20.7772 31.8002 22.3834 32.1197C23.9896 32.4391 25.6544 32.2752 27.1674 31.6485C28.6803 31.0218 29.9735 29.9605 30.8833 28.5989C31.7931 27.2372 32.2788 25.6364 32.2788 23.9987C32.2788 21.8028 31.4064 19.6967 29.8536 18.1439C28.3008 16.5911 26.1947 15.7188 23.9988 15.7188Z",
    stroke: "#FAFAFB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.913cce50492fcb3b79d56a255aa1d74d.svg";
export { ForwardRef as ReactComponent };